document.addEventListener('DOMContentLoaded', () => {
  let grid =
    document.querySelector('[data-product-grid]') ||
    document.querySelector('.product-grid') ||
    document.querySelector('.product-list') ||
    document.querySelector('[id*="CollectionProductGrid"]') ||
    document.querySelector('.collection .grid');

  if (!grid) return;

  document.documentElement.classList.add('infinite-active');

  const pagSelector = 'nav.pagination, .pagination, [data-pagination], .pagination-wrapper, .collection__pagination';

  const getPageNum = (href) => {
    try {
      const u = new URL(href, window.location.origin);
      return parseInt(u.searchParams.get('page') || '1', 10);
    } catch {
      const match = (href || '').match(/[\?&]page=(\d+)/);
      return match ? parseInt(match[1], 10) : 1;
    }
  };

  const normalizeProductKey = (href) => {
    try {
      const u = new URL(href, location.origin);
      const path = u.pathname;
      const i = path.indexOf('/products/');
      if (i >= 0) {
        const rest = path.slice(i + '/products/'.length);
        const handle = rest.split('/')[0];
        return `/products/${handle}`;
      }
      return path;
    } catch {
      const i = (href || '').indexOf('/products/');
      return i >= 0 ? '/products/' + href.slice(i + '/products/'.length).split('/')[0] : href;
    }
  };

  const hidePagination = () => {
    document
      .querySelectorAll(pagSelector)
      .forEach(el => el.style.setProperty('display', 'none', 'important'));
  };

  let lastLoadedPage = getPageNum(window.location.href);
  let seen = new Set(
    Array.from((grid || document).querySelectorAll('a[href*="/products/"]')).map(a =>
      normalizeProductKey(a.href || a.getAttribute('href'))
    )
  );

  let loading = false;
  let observer = null;

  const pagContainer = document.querySelector(pagSelector);
  const container = pagContainer?.parentNode || grid.parentNode;
  const existingLoader = document.getElementById('infinite-loader');
  const existingSentinel = document.getElementById('infinite-sentinel');

  const loader = existingLoader || (() => {
    const el = document.createElement('div');
    el.id = 'infinite-loader';
    el.textContent = 'Loading…';
    el.style.cssText = 'text-align:center; padding:12px 0; display:none;';
    container.appendChild(el);
    return el;
  })();

  const sentinel = existingSentinel || (() => {
    const el = document.createElement('div');
    el.id = 'infinite-sentinel';
    container.appendChild(el);
    return el;
  })();

  hidePagination();

  function stopInfinite(msg = 'All items loaded') {
    if (observer) try { observer.disconnect(); } catch(e){}
    loader.textContent = msg;
    loader.style.display = 'block';
    // set flag on body
    document.body.setAttribute('data-stop-loading', 'true');
  }

  function getNextPageLink() {
    const pag = document.querySelector(pagSelector);
    if (!pag) return null;

    let link =
      pag.querySelector('a[rel="next"]') ||
      pag.querySelector('a[aria-label*="Next"]') ||
      pag.querySelector('.pagination__item--next a, a.pagination__item--next');

    if (link) return link;

    const links = Array.from(pag.querySelectorAll('a[href*="page="]'));
    let candidate = null;
    let bestPage = Infinity;

    links.forEach(a => {
      const href = a.getAttribute('href') || a.href;
      const p = getPageNum(href);
      if (p > lastLoadedPage && p < bestPage) {
        bestPage = p;
        candidate = a;
      }
    });

    return candidate;
  }

  async function loadNextPage() {
    if (document.body.getAttribute('data-stop-loading') === 'true') {
      return; // do nothing if stop flag set
    }

    const link = getNextPageLink();
    if (!link || loading) return;

    const nextHref = link.getAttribute('href') || link.href;
    const nextPage = getPageNum(nextHref);

    if (nextPage <= lastLoadedPage) return;

    loading = true;
    loader.style.display = 'block';

    try {
      const res = await fetch(nextHref, { credentials: 'same-origin' });
      const html = await res.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');

      const nextGrid =
        doc.querySelector('[data-product-grid]') ||
        doc.querySelector('.product-grid') ||
        doc.querySelector('.product-list') ||
        doc.querySelector('[id*="CollectionProductGrid"]') ||
        doc.querySelector('.collection .grid');

      let appended = 0;

      if (nextGrid) {
        const children = Array.from(nextGrid.children);
        for (const el of children) {
          const a = el.querySelector && el.querySelector('a[href*="/products/"]');
          const key = a ? normalizeProductKey(a.getAttribute('href') || a.href) : null;

          if (!key || !seen.has(key)) {
            if (key) seen.add(key);
            grid.appendChild(el.cloneNode(true));
            appended++;
          }
        }
      } else {
        const cards = doc.querySelectorAll('.product-card');
        if (cards && cards.length) {
          Array.from(cards).forEach(card => {
            const a = card.querySelector && card.querySelector('a[href*="/products/"]');
            const key = a ? normalizeProductKey(a.getAttribute('href') || a.href) : null;
            if (!key || !seen.has(key)) {
              if (key) seen.add(key);
              grid.appendChild(card.cloneNode(true));
              appended++;
            }
          });
        }
      }

      const newPag = doc.querySelector(pagSelector);
      const oldPag = document.querySelector(pagSelector);
      if (oldPag && newPag) oldPag.replaceWith(newPag);
      else if (oldPag && !newPag) oldPag.remove();

      hidePagination();
      if (nextPage > lastLoadedPage) lastLoadedPage = nextPage;
      if (!getNextPageLink()) return stopInfinite();

      if (appended > 0) {
        if (window.Prestige && typeof window.Prestige.reinitProductCards === 'function') {
          try { window.Prestige.reinitProductCards(grid); } catch (e) { /* ignore */ }
        }
      }

      setupObserver(true);
    } catch (e) {
      console.error('Infinite scroll error:', e);
      stopInfinite('Error loading more items');
    } finally {
      loading = false;
      if (getNextPageLink()) loader.style.display = 'none';
    }
  }

  function setupObserver(reset = false) {
    if (observer && reset) observer.disconnect();
    if (!getNextPageLink()) return stopInfinite();
    if (observer && !reset) return;

    observer = new IntersectionObserver(
      entries => entries.forEach(entry => entry.isIntersecting && loadNextPage()),
      { rootMargin: '600px 0px', threshold: 0 }
    );

    const s = document.getElementById('infinite-sentinel');
    if (s) {
      observer.observe(s);
    } else {
      const fallback = grid.lastElementChild;
      if (fallback) observer.observe(fallback);
    }
  }

  function reinitAfterFilter() {
    grid =
      document.querySelector('[data-product-grid]') ||
      document.querySelector('.product-grid') ||
      document.querySelector('.product-list') ||
      document.querySelector('[id*="CollectionProductGrid"]') ||
      document.querySelector('.collection .grid');

    seen = new Set(
      Array.from((grid || document).querySelectorAll('a[href*="/products/"]')).map(a =>
        normalizeProductKey(a.href || a.getAttribute('href'))
      )
    );

    lastLoadedPage = getPageNum(window.location.href) || 1;

    const cont = document.querySelector(pagSelector)?.parentNode || grid?.parentNode;
    if (cont && container !== cont) {
      try { cont.appendChild(loader); cont.appendChild(sentinel); } catch(e){}
    }

    hidePagination();

    if (observer) try { observer.disconnect(); } catch(e){}
    observer = null;
    setupObserver(true);
  }

  (function hookHistory() {
    const fire = () => {
      setTimeout(() => reinitAfterFilter(), 50);
    };
    ['pushState', 'replaceState'].forEach(fn => {
      const orig = history[fn];
      history[fn] = function () {
        const ret = orig.apply(this, arguments);
        fire();
        return ret;
      };
    });
    window.addEventListener('popstate', () => setTimeout(() => reinitAfterFilter(), 50));
  })();

  const mutationObserver = new MutationObserver((mutations) => {
    let touched = false;
    for (const m of mutations) {
      if (m.addedNodes && m.addedNodes.length) {
        for (const n of m.addedNodes) {
          if (n && (n.matches && n.matches(pagSelector) || (n.querySelector && n.querySelector(pagSelector)) || n.querySelector && n.querySelector('[data-product-grid]') )) {
            touched = true; break;
          }
        }
      }
      if (m.removedNodes && m.removedNodes.length) {
        for (const n of m.removedNodes) {
          if (n && (n.matches && n.matches(pagSelector) || (n.querySelector && n.querySelector(pagSelector)) || n.querySelector && n.querySelector('[data-product-grid]') )) {
            touched = true; break;
          }
        }
      }
      if (touched) break;
    }
    if (touched) {
      clearTimeout(window.__infinite_reinit_timeout);
      window.__infinite_reinit_timeout = setTimeout(() => {
        try { reinitAfterFilter(); } catch(e){ console.warn(e); }
      }, 80);
    }
  });

  mutationObserver.observe(document.body, { childList: true, subtree: true });

  window.addEventListener('sizeFilter:paginationUpdated', () => setTimeout(() => reinitAfterFilter(), 40));
  window.addEventListener('collection:filters:applied', () => setTimeout(() => reinitAfterFilter(), 40));
  window.addEventListener('filters:changed', () => setTimeout(() => reinitAfterFilter(), 40));

  setupObserver();

  function clearStopLoadingAndReinit() {
    document.body.removeAttribute('data-stop-loading');

    if (loader) {
      loader.textContent = 'Loading…';
      loader.style.display = 'none';
    }

    if (observer) try { observer.disconnect(); } catch(e){}
    observer = null;
    reinitAfterFilter();
  }

  const filterSelector = 'input[type="checkbox"][name^="filter."], input[type="checkbox"][name*="filter"], .checkbox-control input[type="checkbox"], .facets input[type="checkbox"], .filters input[type="checkbox"]';

  document.addEventListener('click', (e) => {
    const t = e.target;
    if (t instanceof Element && (t.matches(filterSelector) || t.closest(filterSelector))) {
      setTimeout(clearStopLoadingAndReinit, 40);
    }
  }, { capture: true });

  document.addEventListener('change', (e) => {
    const t = e.target;
    if (t instanceof Element && (t.matches(filterSelector) || t.closest(filterSelector))) {
      setTimeout(clearStopLoadingAndReinit, 40);
    }
  }, { capture: true });
});
